import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { TruncateWithTooltip } from '../../lib';

interface TQLEditorTableViewProps {
    data: any; // we can get anything based on the tql query.
}

export const TQLEditorTableView = ({
    data,
}: TQLEditorTableViewProps): React.JSX.Element => {
    const [columns, setColumns] = useState<any[]>([]);

    useEffect(() => {
        if (!data || data.length === 0) {
            return;
        }

        //Extract column headers from the keys of the first object
        const dynamicColumns: any[] = Object.keys(data[0]).map((key) => {
            return {
                field: key,
                headerName: key,
                editable: false,
                flex: 2,
                renderCell: (params: any): JSX.Element => {
                    if (!params.value) return <></>;

                    const normalizedValue: any =
                        typeof params.value === 'object' ||
                        Array.isArray(params.value)
                            ? JSON.stringify(params.value) //display nested data
                            : structuredClone(params.value); //parse string to remove outer quotes

                    return <TruncateWithTooltip text={`${normalizedValue}`} />;
                },
            };
        });
        setColumns(dynamicColumns);
    }, [data]);

    return (
        <DataGrid
            rows={data}
            columns={columns}
            getRowId={(): string => crypto.randomUUID().toString()}
            rowHeight={38}
            disableRowSelectionOnClick
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 25,
                    },
                },
            }}
            pageSizeOptions={[25, 50, 100]}
            pagination
        />
    );
};
